/** Fattura Affidya che può richiedere ricerca/collegamento documento FIC esistente. */
export function fatturaRecuperabileCollegamentoFic(fattura) {
  if (!fattura || fattura.origine_documento === "fic_collegata") return false;
  const stato = fattura.stato;
  const statiOk = new Set(["bozza", "generata", "approvata", "rifiutata", "scartata"]);
  if (!statiOk.has(stato)) return false;

  const errText = `${fattura.ultimo_errore_sdi || ""} ${fattura.ultimo_errore_sdi_leggibile || ""}`.toLowerCase();
  const conflitto409 = errText.includes("409") || errText.includes("stesso numero");

  if (fattura.provider_id && !conflitto409) return false;
  return conflitto409 || (!fattura.provider_id && Boolean(fattura.ultimo_errore_sdi));
}

export function fatturaHaConflittoNumeroFic(fattura) {
  const errText = `${fattura?.ultimo_errore_sdi || ""} ${fattura?.ultimo_errore_sdi_leggibile || ""}`.toLowerCase();
  return errText.includes("409") || errText.includes("stesso numero");
}
